export default [
  {
    path: '/scales',
    name: 'scales',
    component: () => import('./Scales.vue'),
    meta: {
      requiresAuth: true,
      name: 'Escala',
    },
  },
]
